import { useMemo } from "react";

const COLORS = ["var(--primary)", "var(--primary)", "var(--danger)", "#ff8c3b"];

export const Embers = ({ count = 14 }) => {
  const particles = useMemo(
    () =>
      [...Array(count)].map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 2.5 + Math.random() * 3.5,
        duration: 7 + Math.random() * 7,
        delay: Math.random() * 10,
        drift: (Math.random() - 0.5) * 60,
        color: COLORS[i % COLORS.length],
      })),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden data-testid="hero-embers">
      {particles.map((p) => (
        <span
          key={p.id}
          className="ember"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            boxShadow: `0 0 ${p.size * 2}px ${p.color}`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            "--drift": `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
};
